import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'signalRange';

export class SignalRange extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
